const signalR = require("@microsoft/signalr");
import { vueObj } from "../../main";
import Cookies from "@/utils/cookie";

const createIdleConnection = () => ({
  state: "Disconnected",
  on() {},
  off() {},
  start() {
    return Promise.resolve();
  },
  stop() {
    return Promise.resolve();
  },
  invoke() {
    return Promise.reject(new Error("CaseBattleHub is not connected"));
  },
});

export default {
  conn: createIdleConnection(),
  hasConnection: false,
  isHappyCoin: null,
  startPromise: null,
  onConnected: null,
  onReconnected: null,
  battleRouteNames: [
    "battle",
    "battleDetail",
    "battleHistory",
    "happyCoinBattle",
    "happyCoinBattleDetail",
  ],
  isBattleRoute(route) {
    return this.battleRouteNames.indexOf(route && route.name) > -1;
  },
  getHubUrl(isHappyCoin) {
    const baseUrl = `${configs.serveBaseURL.replace(/(.*)\/api/, "$1/hubs")}/CaseBattle`;
    return `${baseUrl}?isHappyCoin=${isHappyCoin ? "true" : "false"}`;
  },
  createConnection(isHappyCoin) {
    this.conn = new signalR.HubConnectionBuilder()
      .withUrl(this.getHubUrl(isHappyCoin), {
        accessTokenFactory: () => Cookies.getToken(),
      })
      .withAutomaticReconnect([1000, 2000, 3000, 4000, 5000, 6000])
      .configureLogging(signalR.LogLevel.Error)
      .build();
    this.hasConnection = true;
    this.isHappyCoin = isHappyCoin;

    //收到全局提示
    this.conn.on("GCMsgRecv", (success, message) => {
      if (success) {
        vueObj.$toast.success(message);
      } else {
        vueObj.$toast.error(message);
      }
    });

    // 生命周期
    this.conn.onreconnecting((error) => {
      //vueObj.$toast.info("正在尝试重新连接服务器...");
    });

    this.conn.onreconnected((connectionId) => {
      //vueObj.$toast.success("重新连接服务器成功");

      if (this.onReconnected) {
        this.onReconnected();
      }
    });

    //this.conn.onclose(error => {
    //});
  },
  startConnection() {
    if (this.conn.state == "Connected" || this.conn.state == "Reconnecting") {
      return Promise.resolve(this.conn);
    }

    if (this.conn.state == "Connecting") {
      return this.startPromise || Promise.resolve(this.conn);
    }

    this.startPromise = this.conn
      .start()
      .then(() => {
        this.startPromise = null;
        if (this.onConnected) {
          this.onConnected();
        }
        return this.conn;
      })
      .catch((error) => {
        this.startPromise = null;
        throw error;
      });

    return this.startPromise;
  },
  restartHub(isHappyCoin) {
    const stopPromise =
      this.hasConnection && this.conn && typeof this.conn.stop == "function"
        ? this.conn.stop().catch(() => {})
        : Promise.resolve();

    this.conn = createIdleConnection();
    this.hasConnection = false;
    this.isHappyCoin = null;
    this.startPromise = null;

    const restartPromise = stopPromise
      .then(() => {
        this.startPromise = null;
        this.createConnection(!!isHappyCoin);
        return this.startConnection();
      })
      .catch((error) => {
        this.startPromise = null;
        throw error;
      });
    this.startPromise = restartPromise;
    return restartPromise;
  },
  stopHub() {
    const stopPromise =
      this.hasConnection && this.conn && typeof this.conn.stop == "function"
        ? this.conn.stop().catch(() => {})
        : Promise.resolve();

    this.conn = createIdleConnection();
    this.hasConnection = false;
    this.isHappyCoin = null;
    this.startPromise = null;
    this.onConnected = null;
    this.onReconnected = null;

    return stopPromise;
  },
  //初始化连接
  initHub: function (isHappyCoin = false) {
    const nextIsHappyCoin = !!isHappyCoin;

    if (!this.hasConnection && this.startPromise) {
      return this.startPromise;
    }

    if (this.hasConnection && this.isHappyCoin !== nextIsHappyCoin) {
      return this.restartHub(nextIsHappyCoin);
    }

    if (!this.hasConnection) {
      this.createConnection(nextIsHappyCoin);
    }

    if (this.conn.state == "Disconnecting") {
      return this.restartHub(nextIsHappyCoin);
    }

    return this.startConnection();
  },
};
